import axios from 'axios';
import config from 'config';
import { authHeader, loggedIn, loggedInUser } from '@/services/authentication';
import { eventBus } from '@/eventBus';
import { version } from '@/../package.json';

const instance = axios.create({
    baseURL: config.apiUrl,
});

instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
instance.defaults.headers.common['Zyp-User-Agent'] = `APP-${version}`;

instance.interceptors.request.use(
    (request) => {
        const user = loggedInUser();
        if (loggedIn()) {
            request.headers = {
                ...request.headers,
                ...authHeader(),
            };
            if (user && user.locale) {
                request.headers['Accept-Language'] = user.locale;
            }
        }
        return request;
    },
);

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (!error.response) {
            eventBus.$emit('offline');
        } else {
            const { status } = error.response;

            // Show the user a 500 error
            if (status >= 500) {
                eventBus.$emit('error', error.response.data.message);
            }

            // Handle Forbidden
            if (status === 403) {
                eventBus.$emit('forbidden', error.response.data.message);
            }

            // Handle Unauthorized
            if (status === 401 || status === 472) {
                eventBus.$emit('unauthorized', error);
            }
        }

        return Promise.reject(error);
    },
);

export default instance;
